import React, { Component } from 'react';
import { Modal, Radio, Checkbox, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;

const backData = [{id: '1', name:'第一无锡人民医院'}, {id: '2', name:'第二无锡人民医院'},{id: '3', name:'第三无锡人民医院'},]

class BatchTransfer extends Component {
    state = {
        visible: false,
        loading: false,
        type: 'ALL_CONFIRM',
        hospitalId: [],
        confirmHospitalList: [],
    }

    show = () => {
        this.setState({
            visible: true,
        },() => {
            this.queryConfirmHospital();
        });
    }

    queryConfirmHospital = () => {
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryConfirmHospital,
            data: { },
            dataType: 'json',
            doneResult: res => {
                this.setState({ confirmHospitalList: res.success })
            },
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({
            visible: false,
            loading: false,
            type: 'ALL_CONFIRM',
            hospitalId: [],
        });
    }

    submit = () => {
        const { type, hospitalId = [] } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.confirmBatchFillingRate,
            data: {
                type,
                hospitalId: hospitalId.join(','),
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.props.loadData();
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    radioChange = (e) => {
        this.setState({
            type: e.target.value,
        });
    }

    checkboxChange = (value) => {
        this.setState({
            hospitalId: value,
        });
    }

    render() {
        const { visible, loading, type, hospitalId, confirmHospitalList = [] } = this.state;
        return (
            <Modal
                title="批量确认"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                loading={loading}
                width="500px"
            >
                <div style={{display: 'flex', flexDirection: 'column', padding: '20px 30px'}}>
                    <div style={{ marginBottom: 15 }}>请选择确认范围：</div>
                    <div style={{ marginLeft: 30, marginBottom: 15 }}>
                        <RadioGroup style={{ width: 100 }} onChange={this.radioChange} value={type}>
                            <Radio style={{ marginBottom: 15 }} value={'ALL_CONFIRM'}>全部确认</Radio>
                            <Radio value={'HOSPITAL_CONFIRM'}>按医院确认</Radio>
                        </RadioGroup>
                    </div>
                    {type === 'HOSPITAL_CONFIRM' &&
                        <div style={{ marginLeft: 70, display: 'block'}}>
                            <CheckboxGroup onChange={this.checkboxChange} value={hospitalId}>
                                {
                                    confirmHospitalList.map(el => <Checkbox 
                                            style={{ 
                                                marginBottom: 15,
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                width: '100%' // 确保独占一行
                                            }} 
                                            value={el.hospitalId}
                                        >
                                            {`${el.hospitalName}${el.courtyardArea ? `（${el.courtyardArea}）` : ''}`}
                                        </Checkbox>)
                                }
                            </CheckboxGroup>
                        </div>
                    }
                </div>
            </Modal>
        );
    }
}

export default BatchTransfer;


// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/BatchTransfer.js